import { defaultAmisConvertState } from './module-amisconvert-state';

export default {
	/**
	 * Reset state module amisconvert.
	 * Giữ no-op để tương thích với ResetModules khi đổi mã số thuế (changeTaxCode).
	 * Trạng thái AmisConvertStatus nay nằm trong module taxpayerinfo — không còn ở đây.
	 */
	resetState(state) {
		Object.assign(state, defaultAmisConvertState);
	}
};
